import api from '@/shared/api';
import type { ApiResponse } from '@/shared/lib';
import type { RecordChangelogEntry } from '../model/record-modal.types';

/**
 * Full revision history of the record `id` belongs to, from the newest to the oldest. `id` is the
 * id of the row that opened the history modal, which cuts the list at its own revision.
 */
export async function listRecordChangelog(id: number): Promise<RecordChangelogEntry[]> {
  const response = await api.get<ApiResponse<RecordChangelogEntry[]>>(
    `/matrices/${id}/revision-history`
  );

  return response.data.data ?? [];
}
